import { color } from "src/styles/globals";
import styled from "styled-components";
import CommonButton from "src/components/Common/Button";
import { Body as SundayBody, Title as SundayTitle } from "sunday-component";

export const Body = styled(SundayBody)`
  color: ${color.charcoal10};
`;

export const Title = styled(SundayTitle)``;

export const Container = styled.div`
  margin: 0px 0px 24px;
`;

export const Content = styled.div`
  margin: 0px 0px 16px 0px;
`;

export const Button = styled(CommonButton)`
  padding: 13px 28px;
  height: 50px !important;
`;

export const InfoSection = styled.div`
  height: 24px;
  margin: 8px 0px 8px;
`;

export const InfoTitleContainer = styled.div`
  display: inline-block;
  vertical-align: top;
  margin: 0px 0px 0px 8px;
`;
